import {MatIcon} from "@angular/material/icon";
import {Component, input} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {SimStatusPalette} from "@models";
import {Translations} from "@translations";

@Component({
	selector: "sim-warning-message",
	imports: [MatIcon, TranslateModule],
	animations: [zoomInOnEnterAnimation({duration: 175}), zoomOutOnLeaveAnimation({duration: 175})],
	host: {
		"[@zoomInOnEnter]": "true",
		"[@zoomOutOnLeave]": "true",
		class: SimStatusPalette.warn,
	},
	templateUrl: "./warning-message.component.html",
	styleUrl: "./warning-message.component.scss",
})
export class WarningMessageComponent {
	public readonly text = input.required<string>();
	protected readonly T = Translations;
}
